export default __webpack_public_path__ + "02423d7b05c0394c5f69533a07d6675a.svg";